import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Specializations from "./components/Specialization/Specializations";
import Thank_you from "./components/thank-you/Thank_you";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";

function App() {
  return (
    <>
      {/* <ScrollToTop /> */}
      <Header />
      <Routes>
        <Route path="/" element={<Specializations />} />
        <Route path="/thank-you" element={<Thank_you />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
